/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { SelectInput } from 'src/components/ts-components/SelectInput'
import { SwitchInput } from 'src/components/ts-components/SwitchInput'
import Text from 'src/components/ts-components/Text'
import { TextInput } from 'src/components/ts-components/TextInput'
import { useDivisionSetupContext } from '../../context'

// const DeleteButton = ({ ...props }) => {
//   return (
//     <button
//       css={css`
//         display: flex;
//         padding: 8px 16px 8px 8px;
//         justify-content: center;
//         align-items: center;
//         gap: 8px;
//         border-radius: 8px;
//         border: 1px solid ${colors.ERROR_200};
//         box-shadow: 0px 2px 0px 0px rgba(5, 145, 255, 0.1);
//         font-family: ${isCanlan
//           ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif !important;'
//           : 'BarlowCondensed, Arial, Helvetica, sans-serif !important;'};
//       `}
//       {...props}
//     >
//       <DeleteOutlined
//         css={css`
//           color: ${colors.ERROR_200};
//         `}
//         width={24}
//         height={24}
//       />
//       <Text variant='paragraphMedium' weight='semiBold' color={colors.WHITE}>
//         DELETE DIVISION
//       </Text>
//     </button>
//   )
// }

const GeneralSettings = () => {
  const { state, setState, division, types } = useDivisionSetupContext()

  return (
    <div
      css={css`
        display: flex;
        padding: 16px;
        gap: 16px;
        flex-direction: column;
        align-items: flex-end;
        position: relative;
        overflow-y: auto;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 8px;
          align-self: stretch;
        `}
      >
        <Text variant='captionLarge' weight='semiBold'>
          General Settings
        </Text>
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 8px;
          align-self: stretch;
        `}
      >
        <TextInput
          label='Division Name *'
          value={division?.name || ''}
          customError={''}
          fieldErrors={[]}
          name='divisionName'
          setValue={() => {
            console.log('setValue')
          }}
          disabled={true}
        />
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 8px;
          align-self: stretch;
        `}
      >
        <Text variant='captionXSmall' weight='semiBold' color={colors.WHITE}>
          Age Range
        </Text>
        <div
          css={css`
            display: flex;
            align-items: flex-start;
            gap: 16px;
            align-self: stretch;
          `}
        >
          <div
            css={css`
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 8px;
              flex: 1 0 0;
            `}
          >
            <SelectInput
              label='Age'
              options={
                types?.age_range?.map((age) => ({
                  label: age.name,
                  value: age.id,
                })) || []
              }
              value={state.divisionAge || types?.age_range?.[0]?.id || '1'}
              onChange={(value) => {
                setState({ ...state, divisionAge: value as string })
              }}
              fieldErrors={[]}
              customError={''}
              disabled={false}
              name='divisionAge'
            />
          </div>
          <div
            css={css`
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 8px;
              flex: 1 0 0;
            `}
          >
            <SelectInput
              label='Gender'
              options={
                types?.gender?.map((gender) => ({
                  label: gender.name,
                  value: gender.id,
                })) || []
              }
              value={state.gender || types?.gender?.[0]?.id || '1'}
              onChange={(value) => {
                setState({
                  ...state,
                  gender: value as string,
                })
              }}
              fieldErrors={[]}
              customError={''}
              disabled={false}
              name='divisionType'
            />
          </div>
        </div>
      </div>
      <div
        css={css`
          display: flex;
          align-items: flex-start;
          gap: 16px;
          align-self: stretch;
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
            flex: 1 0 0;
          `}
        >
          <SelectInput
            label='Day of Week'
            options={
              types?.day_of_week?.map((day) => ({
                label: day.name,
                value: day.id,
              })) || []
            }
            value={state.daysOfWeek || types?.day_of_week?.[0]?.id || ''}
            onChange={(value) => {
              setState({
                ...state,
                daysOfWeek: value as string,
              })
            }}
            fieldErrors={state.fieldErrors}
            customError={state.customError}
            name='day_of_week'
            disabled={false}
          />
        </div>
      </div>
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 24px;
          align-self: stretch;
        `}
      >
        <SwitchInput
          title='Enable Max Players Per Team'
          subtitle='Set a maximum number of players allowed per team'
          value={state.enableMaxPlayers || false}
          onChange={(value) => {
            setState((prev) => ({
              ...prev,
              enableMaxPlayers: value,
              maxPlayersPerTeam: value ? prev.maxPlayersPerTeam : null,
            }))
          }}
        />
      </div>
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 24px;
          align-self: stretch;
        `}
      >
        <SwitchInput
          title='Enable Max Teams'
          subtitle='Set a maximum number of teams allowed'
          value={state.enableMaxTeams || false}
          onChange={(value) => {
            setState((prev) => ({
              ...prev,
              enableMaxTeams: value,
              maxTeams: value ? prev.maxTeams : null,
            }))
          }}
        />
      </div>
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 24px;
          align-self: stretch;
        `}
      >
        <SwitchInput
          title='Enable Players Per Bucket'
          subtitle='Set a maximum number of players allowed per bucket'
          value={state.enableMaxPlayersPerBucket || false}
          onChange={(value) => {
            setState((prev) => ({
              ...prev,
              enableMaxPlayersPerBucket: value,
              maxPlayersPerBucket: value ? prev.maxPlayersPerBucket : null,
            }))
          }}
        />
      </div>
      <div
        css={css`
          display: flex;
          align-items: flex-start;
          gap: 16px;
          align-self: stretch;
        `}
      >
        {state.enableMaxPlayers && (
          <div
            css={css`
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 8px;
              flex: ${state.enableMaxTeams && state.enableMaxPlayersPerBucket
                  ? '0.33'
                  : state.enableMaxTeams || state.enableMaxPlayersPerBucket
                  ? '0.5'
                  : '1'}
                0 0;
            `}
          >
            <TextInput
              label='Max Players Per Team'
              value={state?.maxPlayersPerTeam?.toString() || ''}
              setValue={(value) => {
                setState((prevState) => ({
                  ...prevState,
                  maxPlayersPerTeam: parseInt(value, 10),
                }))
              }}
              fieldErrors={state?.fieldErrors}
              customError={state?.customError}
              disabled={false}
              name='maxPlayersPerTeam'
              type='number'
              min={0}
            />
          </div>
        )}
        {state.enableMaxTeams && (
          <div
            css={css`
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 8px;
              flex: ${state.enableMaxPlayers && state.enableMaxPlayersPerBucket
                  ? '0.33'
                  : state.enableMaxPlayers || state.enableMaxPlayersPerBucket
                  ? '0.5'
                  : '1'}
                0 0;
            `}
          >
            <TextInput
              label='Max Number of Teams'
              value={state?.maxTeams?.toString() || ''}
              setValue={(value) => {
                setState((prevState) => ({
                  ...prevState,
                  maxTeams: parseInt(value, 10),
                }))
              }}
              fieldErrors={state?.fieldErrors}
              customError={state?.customError}
              disabled={false}
              name='maxTeams'
              type='number'
              min={0}
            />
          </div>
        )}
        {state.enableMaxPlayersPerBucket && (
          <div
            css={css`
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 8px;
              flex: ${state.enableMaxPlayers && state.enableMaxTeams
                  ? '0.33'
                  : state.enableMaxPlayers || state.enableMaxTeams
                  ? '0.5'
                  : '1'}
                0 0;
            `}
          >
            <TextInput
              label='Max Players Per Bucket'
              value={state?.maxPlayersPerBucket?.toString() || ''}
              setValue={(value) => {
                setState((prevState) => ({
                  ...prevState,
                  maxPlayersPerBucket: parseInt(value, 10),
                }))
              }}
              fieldErrors={state?.fieldErrors}
              customError={state?.customError}
              disabled={false}
              name='maxPlayersPerBucket'
              type='number'
              min={0}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default GeneralSettings
